import React, {useState} from 'react'
import Button from "../../../components/Button";
import {useNavigate} from "react-router-dom";
import {PageSection} from "../../../components/PageSection";
import Spinner from "../../../components/Spinner";
import {useQuery} from "react-query";
import ngage from "../../../services/ngage";
import {copyText} from "../../../services/clipboard";
import {useNotifications} from "../../../context/NotificationContext";
import {Code} from "../../../components/Code";

// Component ----

function TwoFactorAuthRecoveryCodes() {
  const navigate = useNavigate();
  const {notify} = useNotifications();

  const [isCopyingCode, setIsCopyingCode] = useState(false);

  const {
    data: recoveryCodes,
    isLoading
  } = useQuery('auth.twoFactorRevoveryCodes', ngage.auth.twoFactorRecoveryCodes, { cacheTime: 0 });

  const firstCodeSet = recoveryCodes ? recoveryCodes.slice(0,4) : [];
  const secondCodeSet = recoveryCodes ? recoveryCodes.slice(4,8) : [];

  async function handleCopyCodes() {
    await copyText({
      value: recoveryCodes?.join('\n'),
      onSuccess: () => {
        setIsCopyingCode(true);
        setTimeout(() => setIsCopyingCode(false), 2000);
      },
      onError: () => notify("error", "Recovery Codes", "Codes could not be copied to the clipboard."),
    });
  }

  return (
    <PageSection
      title='Save your recovery codes'
    >
      <div className="flex flex-col gap-4 text-gray-900 text-sm">
        <p>To ensure you can always access your account, securely store these backup codes.</p>

        <p>You'll need them if your phone is lost or broken, or you can't use your authenticator app. Keep them safe offline (e.g. printed copy) or in a trusted password manager.</p>

        <div className='flex flex-col gap-6 items-center justify-center border border-gray-300 p-5'>
          <div className='flex flex-wrap gap-12 justify-center items-center min-h-[7rem]'>
            {isLoading && <Spinner size={Spinner.sizes.SMALL} color={Spinner.colors.NEUTRAL} />}
            {(!isLoading && recoveryCodes) && (
              <>
                <div className='flex flex-col gap-2'>
                  {firstCodeSet.map(code => <Code code={code} key={code} />)}
                </div>
                <div className='flex flex-col gap-2'>
                  {secondCodeSet.map(code => <Code code={code} key={code} />)}
                </div>
              </>
            )}
          </div>

          <Button
            type='button'
            color={Button.colors.WHITE}
            size={Button.sizes.SMALL}
            onClick={handleCopyCodes}
          >
            <span className={`${isCopyingCode ? 'text-green-600' : ''}`}>
                {isCopyingCode ? 'Copied!' : 'Copy codes'}
            </span>
          </Button>
        </div>

        <div className='flex gap-4 mt-4'>
          <Button
            type='button'
            color={Button.colors.PRIMARY}
            onClick={() => navigate('/user-settings', {replace: true})}
          >
            Confirm and finish
          </Button>
        </div>
      </div>
    </PageSection>
  );
}

export {TwoFactorAuthRecoveryCodes};